import api from '@/api';
import {
  AmazonAccount,
  AmazonAccountCreateRequest,
} from './amazonAccount.types';
import { API_BASE_URL } from '..';

const CONTROLLER = `${API_BASE_URL}/amazon/linking`;

export default {
  async post(data: AmazonAccountCreateRequest) {
    const result = (await api.post(CONTROLLER, data)) as unknown;
    return result as AmazonAccount;
  },

  async get() {
    const result = (await api.get(CONTROLLER, null)) as unknown;
    return result as AmazonAccount;
  },

  async remove() {
    const result = (await api.remove(CONTROLLER, {}, null)) as unknown;
    return result as void;
  },
};
